import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d9e1f3e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "subject-banner d-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "d-flex align-items-center gap-2" }
const _hoisted_5 = { class: "subject-circle me-3" }
const _hoisted_6 = { class: "subject-initial" }
const _hoisted_7 = { class: "subject-title" }
const _hoisted_8 = { class: "subject-subtitle" }
const _hoisted_9 = { class: "current-period-pill text-end" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "current-period-label" }, " Período actual ", -1))
const _hoisted_11 = { class: "current-period-value" }
const _hoisted_12 = { class: "mb-10 d-sm-flex align-items-center justify-content-between" }
const _hoisted_13 = { class: "d-flex align-items-center gap-3 flex-wrap" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title fw-bold mb-0" }, "Evaluación académica", -1))
const _hoisted_15 = { class: "mini-scale-wrapper" }
const _hoisted_16 = { class: "table table-sm table-bordered mb-0 mini-scale-table" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "py-1 px-2" }, "Código"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-1 px-2" }, "Nombre"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-1 px-2 text-center" }, "Mín"),
    /*#__PURE__*/_createElementVNode("th", { class: "py-1 px-2 text-center" }, "Máx")
  ])
], -1))
const _hoisted_18 = { class: "py-1 px-2" }
const _hoisted_19 = { class: "py-1 px-2" }
const _hoisted_20 = { class: "py-1 px-2 text-center" }
const _hoisted_21 = { class: "py-1 px-2 text-center" }
const _hoisted_22 = { class: "d-flex align-items-center gap-1 flex-wrap" }
const _hoisted_23 = { class: "d-flex align-items-center gap-1 flex-wrap" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vr mx-2 d-none d-md-block" }, null, -1))
const _hoisted_25 = { class: "d-flex align-items-center gap-1 flex-wrap" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vr mx-2 d-none d-md-block" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vr mx-2 d-none d-md-block" }, null, -1))
const _hoisted_28 = { class: "d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 mb-12" }
const _hoisted_29 = { class: "small text-muted" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "Estado:", -1))
const _hoisted_31 = ["title"]
const _hoisted_32 = { class: "small text-muted" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "Último borrador:", -1))
const _hoisted_34 = ["title"]
const _hoisted_35 = {
  key: 1,
  class: "badge rounded-pill bg-secondary-subtle text-secondary"
}
const _hoisted_36 = {
  ref: "tableScroll",
  class: "table-scroll-x"
}
const _hoisted_37 = { class: "thead-top-row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "align-middle text-center sticky-col-left bg-white z-3",
  colspan: 1
}, "Estudiante", -1))
const _hoisted_39 = ["colspan"]
const _hoisted_40 = { class: "d-flex justify-content-center align-items-center gap-2" }
const _hoisted_41 = { class: "fw-semibold" }
const _hoisted_42 = ["onClick", "title"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-center align-middle bg-success text-white border-start" }, "Final (100%)", -1))
const _hoisted_44 = { class: "thead-main-row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "sticky-col-left bg-white z-3" }, null, -1))
const _hoisted_46 = ["colspan"]
const _hoisted_47 = { class: "d-flex justify-content-center align-items-center gap-2" }
const _hoisted_48 = { class: "fw-semibold" }
const _hoisted_49 = ["onClick", "title"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-center align-middle bg-success text-white border-start" }, null, -1))
const _hoisted_51 = {
  key: 0,
  class: "d-flex align-items-center gap-1"
}
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["src"]
const _hoisted_54 = {
  key: 1,
  class: "avatar-fallback-sm"
}
const _hoisted_55 = { class: "flex-grow-1 min-w-0" }
const _hoisted_56 = { class: "fw-semibold text-primary text-truncate" }
const _hoisted_57 = ["readonly", "title", "value", "onInput", "onChange", "onBlur", "onKeydown"]
const _hoisted_58 = {
  key: 0,
  class: "text-danger d-block",
  style: {"line-height":"1","margin-top":"2px"}
}
const _hoisted_59 = ["title"]
const _hoisted_60 = {
  key: 3,
  class: "cell-fill fw-bold text-center",
  style: {"background":"#eaf7ef"}
}
const _hoisted_61 = { class: "text-center text-success my-2" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, " Cargando estudiantes...", -1))
const _hoisted_63 = {
  ref: "floatInner",
  class: "floating-inner"
}
const _hoisted_64 = { class: "table text-nowrap mb-0" }
const _hoisted_65 = {
  class: "thead-top-row",
  ref: "floatTopRow"
}
const _hoisted_66 = {
  class: "thead-main-row",
  ref: "floatMainRow"
}
const _hoisted_67 = ["src"]
const _hoisted_68 = {
  key: 1,
  class: "avatar-xl mx-auto mb-10"
}
const _hoisted_69 = { class: "avatar-fallback-xl" }
const _hoisted_70 = { class: "fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_b_row, { class: "mb-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.currentSubjectName ? _ctx.currentSubjectName.charAt(0) : '?'), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.currentSubjectName || 'Sin asignatura'), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.currentGroupName ? `Grupo ${_ctx.currentGroupName}` : 'Sin grupo asignado'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.currentPeriodLabel), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metrics, (m) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: m.Id
                    }, [
                      _createElementVNode("td", _hoisted_18, _toDisplayString(m.Code), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(m.Name), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(Number(m.MinValue).toFixed(2)), 1),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(Number(m.MaxValue).toFixed(2)), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (p) => {
                return (_openBlock(), _createBlock(_component_b_button, {
                  key: p.Id,
                  size: "sm",
                  variant: _ctx.visiblePeriods[Number(p.Id)] ? 'primary' : 'outline-secondary',
                  class: "rounded-pill",
                  onClick: ($event: any) => (_ctx.togglePeriodAndSync(Number(p.Id))),
                  title: p.Description || `Período ${p.PeriodNumber ?? p.Id}`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" P" + _toDisplayString(p.PeriodNumber ?? p.Id) + " ", 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(["ms-2", _ctx.visiblePeriods[Number(p.Id)] ? 'flaticon-checked' : 'flaticon-minus'])
                    }, null, 2)
                  ]),
                  _: 2
                }, 1032, ["variant", "onClick", "title"]))
              }), 128))
            ]),
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.baseSaberList, (s) => {
                return (_openBlock(), _createBlock(_component_b_button, {
                  key: s.Code,
                  size: "sm",
                  variant: _ctx.visibleSabers[s.Code] ? 'success' : 'outline-secondary',
                  class: "rounded-pill",
                  onClick: ($event: any) => (_ctx.toggleSaberAndSync(s.Code)),
                  title: `${s.Name} — ${s.percent}%`
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(s.Code) + " · " + _toDisplayString(s.percent) + "% ", 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(["ms-5", _ctx.visibleSabers[s.Code] ? 'flaticon-checked' : 'flaticon-minus'])
                    }, null, 2)
                  ]),
                  _: 2
                }, 1032, ["variant", "onClick", "title"]))
              }), 128))
            ]),
            _hoisted_26,
            _createVNode(_component_b_form_checkbox, {
              modelValue: _ctx.autosave.enabled,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.autosave.enabled) = $event)),
              switch: "",
              size: "sm",
              onChange: _ctx.onAutosaveToggle,
              title: 'Guardar borrador automáticamente (cada 1 min)'
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Auto-guardar ")
              ]),
              _: 1
            }, 8, ["modelValue", "onChange", "title"]),
            _hoisted_27,
            _createVNode(_component_b_button, {
              size: "sm",
              variant: "primary",
              class: "fw-semibold",
              disabled: _ctx.saving || !_ctx.hasAnythingToSave || _ctx.hasValidationErrors || !_ctx.canEdit,
              onClick: _ctx.persistToServer,
              title: _ctx.canEdit ? (_ctx.navigatorOnline ? 'Guardar en servidor' : 'Sin conexión') : 'Periodo cerrado; no es posible editar'
            }, {
              default: _withCtx(() => [
                (_ctx.saving)
                  ? (_openBlock(), _createBlock(_component_b_spinner, {
                      key: 0,
                      small: "",
                      class: "me-2"
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.saving ? 'Guardando...' : 'Guardar en servidor'), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick", "title"])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("span", {
              class: _normalizeClass(["badge rounded-pill", _ctx.navigatorOnline ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger']),
              title: _ctx.navigatorOnline ? 'Conectado a internet' : 'Sin conexión a internet'
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.navigatorOnline ? 'flaticon-checked' : 'flaticon-warning')
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(_ctx.navigatorOnline ? 'Conectado a internet' : 'Sin conexión a internet'), 1)
            ], 10, _hoisted_31)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            (_ctx.draft.savedAt)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "badge rounded-pill bg-warning-subtle text-warning",
                  title: _ctx.draft.savedAtTitle
                }, _toDisplayString(_ctx.draft.savedAtShort), 9, _hoisted_34))
              : (_openBlock(), _createElementBlock("span", _hoisted_35, "Sin borrador"))
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_b_table, {
            ref: "scoresTable",
            items: _ctx.tableItems,
            fields: _ctx.tableFields,
            small: "",
            hover: "",
            "sticky-header": "62vh",
            "head-row-attrs": { class: 'thead-main-row' },
            class: "table table-ultra-compact-xx text-nowrap mb-0 table-hover-blue"
          }, {
            "thead-top": _withCtx(() => [
              _createElementVNode("tr", _hoisted_37, [
                _hoisted_38,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodHeaderGroups, (pg) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `P-${pg.periodId}`
                  }, [
                    (_ctx.visiblePeriods[pg.periodId])
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 0,
                          class: "text-center align-middle border-start border-end header-group",
                          style: _normalizeStyle(pg.headerStyle),
                          colspan: pg.colspan
                        }, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("span", _hoisted_41, "Período " + _toDisplayString(pg.label), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-xs btn-outline-dark py-0 px-1",
                              onClick: ($event: any) => (_ctx.togglePeriodAndSync(pg.periodId)),
                              title: _ctx.visiblePeriods[pg.periodId] ? 'Ocultar' : 'Mostrar'
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(_ctx.visiblePeriods[pg.periodId] ? 'flaticon-up-arrow' : 'flaticon-down-arrow')
                              }, null, 2)
                            ], 8, _hoisted_42)
                          ])
                        ], 12, _hoisted_39))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                _hoisted_43
              ]),
              _createElementVNode("tr", _hoisted_44, [
                _hoisted_45,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saberHeaderGroups, (sg) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `P${sg.periodId}-${sg.code}`
                  }, [
                    (_ctx.visiblePeriods[sg.periodId] && _ctx.visibleSabers[sg.code])
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 0,
                          class: "text-center align-middle border-start border-end header-group",
                          style: _normalizeStyle(sg.headerStyle),
                          colspan: sg.colspan
                        }, [
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("span", _hoisted_48, _toDisplayString(sg.name) + " · " + _toDisplayString(sg.percent) + "%", 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-xs btn-outline-dark py-0 px-1",
                              onClick: ($event: any) => (_ctx.toggleSaberAndSync(sg.code)),
                              title: _ctx.visibleSabers[sg.code] ? 'Ocultar' : 'Mostrar'
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(_ctx.visibleSabers[sg.code] ? 'flaticon-up-arrow' : 'flaticon-down-arrow')
                              }, null, 2)
                            ], 8, _hoisted_49)
                          ])
                        ], 12, _hoisted_46))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                _hoisted_50
              ])
            ]),
            "cell()": _withCtx((slot) => [
              (slot.field.key === 'StudentName')
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "avatar avatar-sm btn p-0 border-0",
                      onClick: ($event: any) => (_ctx.openPhoto(slot.item.PhotoUrl, slot.item.Initials, slot.item.StudentName)),
                      title: 'Ver foto'
                    }, [
                      (slot.item.PhotoUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: slot.item.PhotoUrl,
                            alt: "foto"
                          }, null, 8, _hoisted_53))
                        : (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(slot.item.Initials), 1))
                    ], 8, _hoisted_52),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, _toDisplayString(slot.item.StudentName), 1)
                    ])
                  ]))
                : (_ctx.isDynamicValueField(slot.field.key))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "cell-fill",
                      style: _normalizeStyle(_ctx.getColStyle(slot.field.key))
                    }, [
                      _createElementVNode("input", {
                        ref: _ctx.cellRef(slot.item.Id, slot.field.key),
                        type: "text",
                        inputmode: "decimal",
                        autocomplete: "off",
                        class: _normalizeClass(["form-control input-xxs text-center fw-semibold", [
                    (_ctx.isOutOfRange(_ctx.scores[slot.item.Id][slot.field.key]) || _ctx.cellError(slot.item.Id, slot.field.key)) ? 'is-invalid' : '',
                    !_ctx.canEdit ? 'bg-light text-muted' : ''
                  ]]),
                        readonly: !_ctx.canEdit,
                        title: _ctx.getTooltip(slot.field.key),
                        value: _ctx.scores[slot.item.Id][slot.field.key] ?? '',
                        onKeydown: [
                          _cache[1] || (_cache[1] = ($event: any) => (_ctx.canEdit ? _ctx.numericKeyGuard($event) : null)),
                          _withKeys(_withModifiers(($event: any) => (_ctx.canEdit ? _ctx.blockIfError(slot.item.Id, slot.field.key, $event) : null), ["prevent"]), ["enter"]),
                          _withKeys(_withModifiers(($event: any) => (_ctx.canEdit ? _ctx.blockIfError(slot.item.Id, slot.field.key, $event) : null), ["prevent"]), ["tab"])
                        ],
                        onInput: ($event: any) => (_ctx.canEdit ? _ctx.onCellInputHard(slot.item.Id, slot.field.key, $event) : null),
                        onChange: ($event: any) => (_ctx.canEdit ? _ctx.onCellCommit(slot.item.Id, slot.field.key) : null),
                        onBlur: ($event: any) => (_ctx.canEdit ? _ctx.enforceIfInvalid(slot.item.Id, slot.field.key) : null)
                      }, null, 42, _hoisted_57),
                      (_ctx.cellError(slot.item.Id, slot.field.key))
                        ? (_openBlock(), _createElementBlock("small", _hoisted_58, _toDisplayString(_ctx.cellError(slot.item.Id, slot.field.key)), 1))
                        : _createCommentVNode("", true)
                    ], 4))
                  : (_ctx.isSubtotalField(slot.field.key))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "cell-fill fw-semibold text-center",
                        style: _normalizeStyle(_ctx.getColStyle(slot.field.key)),
                        title: _ctx.getTooltip(slot.field.key)
                      }, _toDisplayString(_ctx.formatScore(slot.item[slot.field.key])), 13, _hoisted_59))
                    : (slot.field.key === 'FinalScore')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, _toDisplayString(_ctx.formatScore(slot.item.FinalScore)), 1))
                      : _createCommentVNode("", true)
            ]),
            "table-busy": _withCtx(() => [
              _createElementVNode("div", _hoisted_61, [
                _createVNode(_component_b_spinner, { class: "align-middle" }),
                _hoisted_62
              ])
            ]),
            _: 1
          }, 8, ["items", "fields"])
        ], 512)
      ])
    ]),
    _withDirectives(_createElementVNode("div", {
      ref: "floatHost",
      class: "floating-header",
      style: _normalizeStyle(_ctx.float.style)
    }, [
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("table", _hoisted_64, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_65, null, 512),
            _createElementVNode("tr", _hoisted_66, null, 512)
          ])
        ])
      ], 512)
    ], 4), [
      [_vShow, _ctx.float.visible]
    ]),
    _createVNode(_component_b_modal, {
      modelValue: _ctx.photo.open,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.photo.open) = $event)),
      "hide-footer": "",
      title: _ctx.photo.name || 'Foto del estudiante',
      size: "lg",
      "body-class": "text-center"
    }, {
      default: _withCtx(() => [
        (_ctx.photo.url)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.photo.url,
              class: "photo-xl rounded-2 mb-10",
              alt: "foto estudiante"
            }, null, 8, _hoisted_67))
          : (_openBlock(), _createElementBlock("div", _hoisted_68, [
              _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.photo.initials), 1)
            ])),
        _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.photo.name), 1)
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}